// A specialist's next actions and tracked dates on a project, read from its records.
// See docs/Y2026-Q4/design-structured-next-actions-and-dates.md 7.2.
import type { ProjectAgentStatusList } from "../api/hooks/useProjectAgentStatus";
import { projectSource } from "../utils/nextActions";
import { ActionTable } from "./NextActionTable";
import { SectionBlock, SectionCard } from "./SpecialistRowSections";
import { DateTable } from "./TrackedDateTable";

export const NextActionsCard = ({
  agent,
  projectId,
  data,
}: {
  agent: string;
  projectId: string;
  data: ProjectAgentStatusList;
}) => (
  <SectionCard title="Next actions" aside={null} id="next-actions">
    <SectionBlock>
      <ActionTable
        // An earlier briefing is another list, not a change to this one: what has moved
        // since the page opened starts again from it.
        key={data.as_of ?? "now"}
        scope={{ kind: "agent", agent }}
        sources={[projectSource(projectId, data)]}
        empty="No next actions recorded."
        controls
        showArea={false}
        anchored
      />
    </SectionBlock>
  </SectionCard>
);

export const TrackedDatesCard = ({
  agent,
  projectId,
  data,
}: {
  agent: string;
  projectId: string;
  data: ProjectAgentStatusList;
}) => (
  <SectionCard title="Tracked dates" aside={null}>
    <SectionBlock>
      <DateTable
        agent={agent}
        projectId={projectId}
        data={data}
        empty="No tracked dates recorded."
        collapseCovered
        showArea={false}
      />
    </SectionBlock>
  </SectionCard>
);
